module.exports = __webpack_public_path__ + "static/media/ic-clear-filter.d921c7a5.svg";